import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { AssignMutator } from '@/lib/entity/assign'
import type { Converter } from '@/lib/converter/entityFormatter'
import { layered } from '@/lib/layered'
import type { Kysely } from 'kysely'
import type { DB } from '@/lib/kysely-d'
import { sql } from 'kysely'
import { asModifiedField } from '@/lib/converter/entityFormatter'
import { parseIconToChar } from '@/lib/utils/iconUtils'

type AssignSchema = AssignMutator['merged']

export const AssignConverter: Converter<AssignSchema> = {
  icon: () => i18next.t('stages.icon.assign'),
  title: () => i18next.t('stages.table.assign'),
  subTitle: async (merged) => {
    const queryResult = await assignQuery(merged.id!)
    const subTitle = queryResult.nameConcat
    return subTitle.merged() ?? subTitle.get('BASE') ?? ''
  },
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.assign.${column}`)
    return match(column)
      .with('comment', 'visible', (column) => asModifiedField(label, modified[column]!))
      .with('icon', (column) => {
        const v = modified[column]
        if (v === null || v === undefined) return asModifiedField(label, '削除')
        return asModifiedField(label, parseIconToChar(v))
      })
      .with('id', 'project_id', 'user_id', 'job_title_id', () => undefined)
      .exhaustive()
  }
}
const assignQuery = async (id: string) => {
  return await layered(async (db: Kysely<DB>) => {
    const result = await db
      .selectFrom('assign')
      .innerJoin('project', 'assign.project_id', 'project.id')
      .innerJoin('user', 'assign.user_id', 'user.id')
      .select([sql<string>`project.name || ' x ' || user.name`.as('nameConcat')])
      .where('assign.id', '=', id)
      .executeTakeFirst()
    if (!result) {
      return { nameConcat: null }
    }
    return result
  })
}
